/** @module csi/widget/_svg/RightMenuAccordionContainer */
define([
	"dojo/_base/declare",
	"dojo/topic",
	"dijit/_TemplatedMixin",
	"dijit/_WidgetBase",
	"dijit/_WidgetsInTemplateMixin",
	"csi/html",
	"csi/store/Nodes",
	"csi/xml",
	"./_RightMenuAccordionMixin",
	"dojo/text!./resources/RightMenuAccordionContainer.html",
], function(declare, topic, _TemplatedMixin, _WidgetBase, _WidgetsInTemplateMixin, html, Nodes, xml,
		_RightMenuAccordionMixin, template) {

	return declare([_WidgetBase, _TemplatedMixin, _WidgetsInTemplateMixin, _RightMenuAccordionMixin], {
		templateString: template,

		/** @property {RightMenuAccordionItem[]} accordions - container node wrapping accordion container and content sibling */
		accordions: [],

		/** @property {DOMNode} accordionNode - accordion container node that holds accordion item array */
		accordionNode: null,

		/** @property {boolean} bExpandAllAccordions - start with all accordions expanded */
		bExpandAllAccordions: false,

		/** @property {DOMNode} containerNode - container node for accordion container and header node*/
		containerNode: null,

		/** @property {DOMNode} headerNode - header node */
		headerNode: null,

		/** @property {number} initalAccordion - index of accordion to initally expand on create */
		// initalAccordion: null,

		/** @property {Function} onClickPlaceholderArrow - callback to click arrow */
		// onClickPlaceholderArrow: null,

		/** @property {DOMNode} placeholderItemNode - Contains the entire currently selected placeholder type */
		placeholderItemNode: null,

		/** @property {DOMNode} placeholderItemNameNode - Contains name of the currently selected placeholder type */
		placeholderItemNameNode: null,
		
		/** @property {DOMNode} placeholderItemCardNode - Contains slim card for the placeholder type */
		placeholderItemCardNode: null,

		/** @property {Function} refreshPlaceholderTypes - callback to refresh placeholder types, should only exist on product presentation */
		// refreshPlaceholderTypes: null,
		
		/** @property {boolean} subscribe - flag to subscribe or not */
		subscribe: false,

		/** render header callback */
		renderHeaderCallback: null,

		/** Click arrow to go back handler */
		onClickArrow: function() {
			this.onClickPlaceholderArrow();
		},

		/**
		 * Arrange accordions  by a given type
		 * @param {string} type - target accordion type to open
		 */
		arrangeAccordionsByType: function(type) {
			// if this callback exists, we're on product presentation, which has special handling for types
			if (this.refreshPlaceholderTypes) {
				// if a user clicks on the + button for a colorway in product presentation, take them to styles
				if (type === "Colorway") {
					type = "Style";
				} else if (type === "ProductPresentationSetItem") {
					// if a user clicks on the + button for a set item, take them to the set list
					type = "ProductPresentationSet";
				}
				// drill out if drilled into a selected node
				this.refreshPlaceholderTypes();
			}

			for (const accordion of this.accordions) {
				this.expandAccordion(accordion, accordion.placeholderType === type);
			}
		},

		/**
		 * @override
		 * On this life cycle hook, set the total number of children,
		 * append the content node, and set the accordion to reflect expand property
		 */
		postCreate: function() {
			const {
				accordions,
				accordionNode,
				bExpandAllAccordions,
				headerNode,
				placeholderItemCardNode,
				placeholderItemNameNode,
				placeholderItemNode,
				subscribe,
			} = this;

			// render header node if necessary
			if (headerNode) {
				html.clear(placeholderItemCardNode);
				placeholderItemNode.classList.remove(html.CSS_HIDE);

				placeholderItemNameNode.innerHTML = xml.nodeGetName(headerNode);

				const gridRightSelectedPlaceholder = this.renderHeaderCallback(headerNode.$Type);
				const selectedStore = new Nodes({
					data: [headerNode],
				});
				gridRightSelectedPlaceholder.set("store", selectedStore, {}, {});
				gridRightSelectedPlaceholder.startup();

				placeholderItemCardNode.appendChild(gridRightSelectedPlaceholder.domNode);
			}

			accordions.forEach((accordion) => {
				accordionNode.addChild(accordion);
				accordion.startup();
			});

			// arrange accordion based on expand flag
			this.arrangeAccordions(accordions, true, this.initalAccordion, !bExpandAllAccordions);

			if (subscribe) {
				this.own(
					topic.subscribe("/csi/canvas/arrangeAccordionsByType", (type) => this.arrangeAccordionsByType(type)),
				);
			}

			this.inherited(arguments);
		},
	});
});
